import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from './native_badge.module.css';
export const NativeBadge = ({ label = 'CSS Modules badge' })=>/*#__PURE__*/ _jsxs("div", {
        className: `${styles.badge} badge`,
        "data-kind": "css-modules",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: `${styles.token} token`,
                children: "css modules"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: `${styles.label} label`,
                children: label
            })
        ]
    });


export const knightedCss = ".badge,.knighted-badge,.knighted-knighted-badge,.knighted-knighted-knighted-badge{color:#0b1220;letter-spacing:.04em;background:linear-gradient(145deg,#0ea5e9,#2563eb);border:2px dashed #0b122059;border-radius:14px;align-items:center;gap:.5rem;padding:1rem 1.25rem;font-weight:700;display:inline-flex;box-shadow:0 12px 30px #0ea5e940,0 0 0 1px #2563eb40}.token,.knighted-token,.knighted-knighted-token,.knighted-knighted-knighted-token{color:#93c5fd;text-transform:uppercase;letter-spacing:.04em;background:#0b1220;border-radius:999px;padding:.35rem .75rem;font-size:.85rem}.label,.knighted-label,.knighted-knighted-label,.knighted-knighted-knighted-label{text-shadow:0 1px #ffffff59;font-size:1rem}";
